var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"svg",attrs:{"width":_vm.length,"height":_vm.length,"id":"svg"},on:{"mousedown":_vm.clickCallback,"mousemove":_vm.moveCallback,"mouseleave":_vm.leaveCallback}})}
var staticRenderFns = []

export { render, staticRenderFns }